// import React, { forwardRef, useImperativeHandle, useRef } from 'react';
// import generatePDF, { Resolution, Margin } from 'react-to-pdf';
// import { jsPDF } from 'jspdf';

// const PAGE_HEIGHT = 1120; // Define the height of a page (A4 ~ 297mm x 210mm in pixels)
// const GenericHtmlToPdfDownloader = forwardRef((props : any, ref) => {

//      const contentRef = props.contentRef;
//      const downloadFileName = props.downloadFileName;
//      const isExportReportAsPDFActive = props.isExportReportAsPDFActive;
//      const setIsExportReportAsPDFActive = props.setIsExportReportAsPDFActive;
//      const setIsLoadingLocal = props.setIsLoadingLocal;

//    React.useImperativeHandle(ref, () => ({
//      childMethod: handleClick
//    }));

//    const content = contentRef.current as unknown as HTMLElement;
//    const handleClick = async () => {
      
//       setIsExportReportAsPDFActive(true);
//       setIsLoadingLocal(true);
//       if (content) {
//          const origContentWidth = content.style.width;
//          const origContentHeight = content.style.height;
//          const tableElement = contentRef.current.querySelector('table') || '';
//          if (tableElement) {
//             const tableWidth = tableElement.offsetWidth;
//             const tableHeight = tableElement.offsetHeight;
//             content.style.width = tableWidth + 'px';
//             content.style.height = tableHeight + 'px';
//          }
//          const options: any = {
//             filename: downloadFileName,
//             method: 'open',
//             resolution: Resolution.MEDIUM,
//             page: {
//                margin: Margin.SMALL,
//                format: 'A4',
//                orientation: 'portrait',
//             },
//             canvas: {
//                mimeType: 'image/png',
//             },
//             overrides: {
//                pdf: {
//                   compress: true
//                },
//                canvas: {
//                   useCORS: true,
//                }
//             },
//          };
//          await generatePDF(contentRef, options)
//          content.style.width = origContentWidth;
//          content.style.height = origContentHeight;
//          setIsLoadingLocal(false);
//          setIsExportReportAsPDFActive(false);
         
//       }
//    }



//    return (
//       <>
//        <span className="menu-icon custom-menu mb-2">
//                               <i className="bi bi-filetype-pdf fs-6 iconColor">
//                                 <span className="path1"></span>
//                                 <span className="path2"></span>
//                               </i>
//                             </span>
//                             <span className="menu-title custom-menu-fontsize">Download Pdf</span>
//       </>
//    )
// });

// export default GenericHtmlToPdfDownloader;

// import React, { forwardRef, useImperativeHandle, useRef } from 'react';
// import generatePDF, { Resolution, Margin } from 'react-to-pdf';


// const GenericHtmlToPdfDownloader = forwardRef((props : any, ref) => {

//      // Expose specific methods or properties to the parent component via ref
//      const contentRef = props.contentRef;
//      const downloadFileName = props.downloadFileName;
//      const isExportReportAsPDFActive = props.isExportReportAsPDFActive;
//      const setIsExportReportAsPDFActive = props.setIsExportReportAsPDFActive;
//      const setIsLoadingLocal = props.setIsLoadingLocal;
//    React.useImperativeHandle(ref, () => ({
//      childMethod: handleClick
//    }));
//    const content = contentRef.current as unknown as HTMLElement;
//    const handleClick = async () => {
      
//       setIsExportReportAsPDFActive(true);
//       setIsLoadingLocal(true);
//       if (content) {
//          const origContentWidth = content.style.width;
//          const origContentHeight = content.style.height;
//          const tableElement = contentRef.current.querySelector('table') || '';
//          if (tableElement) {
//             const tableWidth = tableElement.offsetWidth;
//             const tableHeight = tableElement.offsetHeight;
//             content.style.width = tableWidth + 'px';
//             content.style.height = tableHeight + 'px';

//          }

//          const options: any = {
//             filename: downloadFileName,
//             // default is `save`
//             method: 'open',
//             // default is Resolution.MEDIUM = 3, which should be enough, higher values
//             // increases the image quality but also the size of the PDF, so be careful
//             // using values higher than 10 when having multiple pages generated, it
//             // might cause the page to crash or hang.
//             resolution: Resolution.MEDIUM,
//             page: {
//                // margin is in MM, default is Margin.NONE = 0
//                margin: Margin.SMALL,
//                // default is 'A4'
//                format: 'A4',
//                // format: 'letter',
//                //format: [tableElement.offsetWidth, tableElement.offsetHeight],
//                // default is 'portrait'
//                orientation: 'portrait',
//                // orientation: 'landscape',
//             },
//             canvas: {
//                // default is 'image/jpeg' for better size performance
//                mimeType: 'image/png',
//                //qualityRatio: 1
//             },
//             // Customize any value passed to the jsPDF instance and html2canvas
//             // function. You probably will not need this and things can break, 
//             // so use with caution.
//             overrides: {
//                // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
//                pdf: {
//                   compress: true
//                   // width: Number(content.style.width) * 0.75
//                   //height:Number(content.style.height)  * 0.75,
//                },
//                // see https://html2canvas.hertzen.com/configuration for more options
//                canvas: {
//                   useCORS: true,
//                   // scrollX: -window.scrollX,
//                   // scrollY: -window.scrollY,
//                   // scale: 0.5
//                   //scale: 1
//                }
//             },
//          };
//          await generatePDF(contentRef, options)
//          content.style.width = origContentWidth;
//          content.style.height = origContentHeight;
//          setIsLoadingLocal(false);
//          setIsExportReportAsPDFActive(false);
         
//       }
//    }



//    return (
//       <>
//        <span className="menu-icon custom-menu mb-2">
//                               <i className="bi bi-filetype-pdf fs-6 iconColor">
//                                 <span className="path1"></span>
//                                 <span className="path2"></span>
//                               </i>
//                             </span>
//                             <span className="menu-title custom-menu-fontsize">Download Pdf</span>
//       </>
//    )
// });

// export default GenericHtmlToPdfDownloader;


import React from 'react';
import generatePDF, { Resolution, Margin } from 'react-to-pdf';


const GenericHtmlToPdfDownloader = async (contentRef : any, downloadFileName: any) => {
   const content = contentRef.current as unknown as HTMLElement;
   
    
      if (content) {
         const origContentWidth = content.style.width;
         const origContentHeight = content.style.height;
         const tableElement = contentRef.current.querySelector('table') || '';
         const reportTitle = contentRef.current.querySelector('#reportTitle') || '';
         const filterdisplay = contentRef.current.querySelector('#filterdisplay') || '';
         if (tableElement) {
            const tableWidth = tableElement.offsetWidth;
            const tableHeight = tableElement.offsetHeight + (reportTitle.offsetHeight ? reportTitle.offsetHeight : 0 )  + (filterdisplay.offsetHeight ? filterdisplay.offsetHeight : 0);
          
            content.style.width = tableWidth + 'px';
            content.style.height = tableHeight + 'px';

         }

         const options: any = {
            filename: downloadFileName,           
            method: 'save',         
            resolution: Resolution.LOW,
            page: {
               margin:  Margin.SMALL,
               format: 'letter',
               orientation: 'landscape',
            },
            canvas: {
               mimeType: 'image/jpeg',
               qualityRatio: 1
            },
            overrides: {
               pdf: {
                  compress: true,
                  width: Number(content.style.width) * 0.75
               },
               canvas: {
                  useCORS: true,
                  scale: 1
               }
            },
         };
         await generatePDF(contentRef, options)
         content.style.width = origContentWidth;
         content.style.height = origContentHeight;         
      }
   



   // return (
      
   //       <a
   //          className={`btn btn-icon btn-active-light-dark btn-sm ms-0 }`}
   //          data-tooltip-id="tooltip-Description"
   //          data-tooltip-content="Export As PDF"
   //          data-tooltip-place="bottom"
   //          onClick={handleClick}
   //       >
            
   //          <i className={`bi bi-filetype-pdf fs-3 iconColor }`}
   //          ></i>

   //       </a>
         
      
   // )
}

export default GenericHtmlToPdfDownloader;


// import React from 'react';
// import generatePDF, { Resolution, Margin } from 'react-to-pdf';


// const GenericHtmlToPdfDownloader = ({ contentRef, downloadFileName}: any) => {
//    const content = contentRef.current as unknown as HTMLElement;
//    const handleClick = async () => {
//       // setIsExportReportAsPDFActive(true);
//       // setIsLoadingLocal(true);
//       if (content) {
//          const origContentWidth = content.style.width;
//          const origContentHeight = content.style.height;
//          const tableElement = contentRef.current.querySelector('table') || '';
//          if (tableElement) {
//             const tableWidth = tableElement.offsetWidth;
//             const tableHeight = tableElement.offsetHeight;
//             content.style.width = tableWidth + 'px';
//             content.style.height = tableHeight + 'px';

//          }

//          const options: any = {
//             filename: downloadFileName,
//             // default is `save`
//             method: 'save',
//             // default is Resolution.MEDIUM = 3, which should be enough, higher values
//             // increases the image quality but also the size of the PDF, so be careful
//             // using values higher than 10 when having multiple pages generated, it
//             // might cause the page to crash or hang.
//             resolution: Resolution.LOW,
//             page: {
//                // margin is in MM, default is Margin.NONE = 0
//                margin: Margin.SMALL,
//                // default is 'A4'
//                format: 'letter',
//                //format: [tableElement.offsetWidth, tableElement.offsetHeight],
//                // default is 'portrait'
//                orientation: 'landscape',
//             },
//             canvas: {
//                // default is 'image/jpeg' for better size performance
//                mimeType: 'image/png',
//                qualityRatio: 1
//             },
//             // Customize any value passed to the jsPDF instance and html2canvas
//             // function. You probably will not need this and things can break, 
//             // so use with caution.
//             overrides: {
//                // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
//                pdf: {
//                   compress: true,
//                   width: Number(content.style.width) * 0.75
//                   //height:Number(content.style.height)  * 0.75,
//                },
//                // see https://html2canvas.hertzen.com/configuration for more options
//                canvas: {
//                   useCORS: true,
//                   // scrollX: -window.scrollX,
//                   // scrollY: -window.scrollY,
//                   scale: 0.5
//                }
//             },
//          };
//          await generatePDF(contentRef, options)
//          content.style.width = origContentWidth;
//          content.style.height = origContentHeight;
//          // setIsLoadingLocal(false);
//          // setIsExportReportAsPDFActive(false);
         
//       }
//    }



//    return (
      
//          <a
//             className={`btn btn-icon btn-active-light-dark btn-sm ms-0 }`}
//             data-tooltip-id="tooltip-Description"
//             data-tooltip-content="Export As PDF"
//             data-tooltip-place="bottom"
//             onClick={handleClick}
//          >
            
//             <i className={`bi bi-filetype-pdf fs-3 iconColor }`}
//             ></i>

//          </a>
         
      
//    )
// }

// export default GenericHtmlToPdfDownloader;


